import { Cover } from '@/elements/Cover';
import classNames from 'classnames/bind';
import { useTranslation } from 'next-i18next';
import styles from './index.module.scss';

const Ad = (props: any) => {
  const { t } = useTranslation('common');
  const cx = classNames.bind(styles);

  const button = {
    cover_button_label: props.cover_button_label ?? t('open-cover'),
    cover_button_color: props.cover_button_color ?? props.brand?.color ?? null,
    cover_button_background: props.cover_button_background ?? null,
  };

  return (
    <div
      className={cx(
        'container',
        props.cover_layout.toLowerCase() ?? 'portrait',
      )}
    >
      <div className={styles.cover}>
        <Cover {...props} {...button} ad />
      </div>
    </div>
  );
};

export default Ad;
